import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import IshaChat from '../components/IshaChat';

export default function SettingsPage() {
  const { api } = useAuth();
  const [pw, setPw] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  const handlePwChange = async () => {
    setMsg('');
    setSaving(true);
    try {
      const res = await api().post('/auth/change-password', pw);
      setMsg(res.data.message || 'Password updated successfully.');
      setPw({ current_password: '', new_password: '', confirm_password: '' });
    } catch (err) {
      setMsg(err.response?.data?.error || 'Failed to change password.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <h1 className="h3 mb-3"><strong>Settings</strong> &amp; Privacy</h1>

      <div className="row">
        <div className="col-lg-8">
          {/* General Settings */}
          <div className="card mb-3">
            <div className="card-header">
              <h5 className="card-title mb-0">General</h5>
            </div>
            <div className="card-body">
              <div className="mb-3">
                <label className="form-label">Language</label>
                <select className="form-select">
                  <option>English</option>
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Timezone</label>
                <select className="form-select">
                  <option>UTC</option>
                  <option>US/Eastern</option>
                  <option>US/Pacific</option>
                  <option>Asia/Kolkata</option>
                </select>
              </div>
            </div>
          </div>

          {/* Notifications */}
          <div className="card mb-3">
            <div className="card-header">
              <h5 className="card-title mb-0">Notifications</h5>
            </div>
            <div className="card-body">
              <div className="form-check form-switch mb-2">
                <input className="form-check-input" type="checkbox" id="emailNotif" defaultChecked />
                <label className="form-check-label" htmlFor="emailNotif">Email notifications for completed scans</label>
              </div>
              <div className="form-check form-switch mb-2">
                <input className="form-check-input" type="checkbox" id="browserNotif" />
                <label className="form-check-label" htmlFor="browserNotif">Browser push notifications</label>
              </div>
              <div className="form-check form-switch mb-2">
                <input className="form-check-input" type="checkbox" id="weeklyReport" defaultChecked />
                <label className="form-check-label" htmlFor="weeklyReport">Weekly summary report</label>
              </div>
            </div>
          </div>

          {/* Privacy */}
          <div className="card mb-3">
            <div className="card-header">
              <h5 className="card-title mb-0">Privacy</h5>
            </div>
            <div className="card-body">
              <div className="form-check form-switch mb-2">
                <input className="form-check-input" type="checkbox" id="dataSharing" />
                <label className="form-check-label" htmlFor="dataSharing">Share anonymized scan data for research</label>
              </div>
              <div className="form-check form-switch mb-2">
                <input className="form-check-input" type="checkbox" id="activityLog" defaultChecked />
                <label className="form-check-label" htmlFor="activityLog">Keep activity log</label>
              </div>
              <hr />
              <button type="button" className="btn btn-outline-danger btn-sm">Delete All Scan Data</button>
            </div>
          </div>
        </div>

        <div className="col-lg-4">
          {/* Security */}
          <div className="card mb-3">
            <div className="card-header">
              <h5 className="card-title mb-0">Security</h5>
            </div>
            <div className="card-body">
              {msg && (
                <div className={`alert ${msg.includes('success') ? 'alert-success' : 'alert-danger'} py-2`}>
                  {msg}
                </div>
              )}
              <div className="mb-3">
                <label className="form-label">Current Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={pw.current_password}
                  onChange={(e) => setPw((p) => ({ ...p, current_password: e.target.value }))}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">New Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={pw.new_password}
                  onChange={(e) => setPw((p) => ({ ...p, new_password: e.target.value }))}
                />
                <small className="text-muted">Minimum 8 characters with mixed case + number</small>
              </div>
              <div className="mb-3">
                <label className="form-label">Confirm Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={pw.confirm_password}
                  onChange={(e) => setPw((p) => ({ ...p, confirm_password: e.target.value }))}
                />
              </div>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                disabled={saving}
                onClick={handlePwChange}
              >
                {saving ? 'Updating...' : 'Update Password'}
              </button>
            </div>
          </div>
        </div>
      </div>
      <IshaChat />
    </>
  );
}
